module.exports = __webpack_public_path__ + "media/images/sampleBet__kranz-e4d91b71ec950e16e98f2a629346c937.png";